import { Component, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'soft-wiegung',
    templateUrl: './wiegung.component.html',
    styleUrls: ['./wiegung.component.scss'],
    imports: [
        AsyncPipe,
        RouterOutlet
    ]
})
export default class WiegungComponent {}
